import { ITransaction, IMember } from '../schemas/entity_set';
import { IMemberService } from '../members/member_service';
import { ILookUpService } from '../settings/lookup_service';
import { ITransactionService, ITransactionFilter } from './transaction_service';
import { Toast, MessageBox, MessageTypes } from "../helpers/message_box"
import { IAuthService } from '../authentication/auth_service';
import { Routes, AppServices, AngularServices, IDataAdapter } from '../helpers/config_keys';

let _: UnderscoreStatic = require("underscore")

class TransactionFormCtrl {
    transactions: ITransaction[];
    //Transaction Data
    title = "Add New Transaction";
    newTransaction: ITransaction;
    //lookUps = ['members']
    members: IMember[]

    //LookUps
    types = ["Saving", "Withdrawal", "Interest"];

    //Page Control
    saving: boolean;
    loading: boolean;
    deleting: boolean;

    static $inject = [AngularServices.Scope, AngularServices.State, AngularServices.StateParams, AppServices.LookUpService, AppServices.TransactionService, AppServices.MemberService, AppServices.AuthService, '$filter'];

    constructor(private $scope: angular.IScope,
        private $state: angular.ui.IStateService,
        private $stateParams: angular.ui.IStateParamsService,
        private lookUpService: ILookUpService,
        private transactionService: ITransactionService,
        private memberService: IMemberService,
        private authService: IAuthService,
        private $filter: angular.IFilterService) {
        this.start()
    }

    save() {
        let theTransaction = angular.copy(this.newTransaction)
        theTransaction.memberId = theTransaction.member.id
        delete theTransaction.member
        this.saving = true
        this.transactionService.save(theTransaction).then((res) => {
            this.saving = false
            if (res.success) this.afterSave(theTransaction.date)
        })
    }

    memberConfig() {
        let self = this;
        let confg = {
            allowClear: true,
            //minimumInputLength: 2,
            placeholder: "Search member by name or number ....",
            query: (q: any) => {
                let data = this.$filter('filter')(this.members, q.term)
                q.callback({ results: data })
            },
            formatResult: (member: IMember) => {
                let markup =
                    `<div class='row-fluid'>
						<div><b style='font-size:16px'>${member.name}</b></div>
						<div>Number: ${member.number}</div>
						<div>Phone Number: ${member.phoneNumber}</div>
					</div>`;
                return markup;
            },
            formatSelection: function (member: IMember) {
                self.newTransaction.member = angular.copy(member)
                self.fetchRecentTransactions()
                self.$scope.$apply()
                return member.name;
            },
            dropdownCssClass: "bigdrop"
        }
        return confg;
    }

    private fetchRecentTransactions() {
        this.transactions = []
        if (!this.newTransaction.member) return
        this.transactionService.recent(this.newTransaction.member.id).then((res) => {
            if (res.success) this.transactions = res.data
        })

    }

    delete() {
        MessageBox.confirm("Delete Transaction", `Are you sure you want to delete ${this.newTransaction.reference}?`).then((yes) => {
            if (yes) {
                this.deleting = true
                this.transactionService.delete(this.newTransaction.id).then((res) => {
                    this.deleting = false
                    if (res.success) { this.afterSave() }
                })
            }
        })
    }

    private fetchMembers() {
        this.memberService.get().then((res) => {
            if (res.success) this.members = res.data
        })
    }

    private loadLookUps() {
        let self: any = this;
        // this.lookUps.forEach((lookup) => {
        //     this.lookUpService.fetch(lookup).then((res) => {
        //         if (res.success) { self[lookup] = res.data }
        //     })
        // })
    }

    private afterSave(date?: Date) {
        date = date || new Date()
        this.transactions = []
        let ele: any = $("#selectedMember");
        ele.select2('data', null)
        this.fetchMembers()
        this.newTransaction = <ITransaction>{ type: this.$stateParams['type'], date }
    }

    private start() {
        let type = this.$stateParams['type']
        let privilege = (type == 'saving') ? "Transaction.Saving" : "Transaction.Withdrawal"
        let authorized = this.authService.isAuthorize(privilege)
        if (!authorized) {
            this.$state.go(Routes.UnAuthorized)
            return
        }

        if (type) {
            this.title = type
            this.fetchMembers()
            this.newTransaction = <ITransaction>{ type, date: new Date() }
        } else {
            this.$state.go(Routes.Transactions)
        }
    }
}

export { TransactionFormCtrl }


// WEBPACK FOOTER //
// ./app/transactions/transaction_form_ctrl.ts